import { Component, Input, OnInit, HostBinding, ChangeDetectionStrategy, Inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { customerConfig, SsoService, SsoPages } from '@uxdf/direct-shared-lib';
import { getSsoLinksState } from '../../../../redux/reducers';
import { InitSsoLinks } from '../../../../redux/actions/actions';
import { filter, take, tap, switchMap } from 'rxjs/operators';
import { State } from '../../../../redux/reducers';
import { State as CustomerState } from '../../../../redux/reducers/customer';
import { State as SsoState } from '../../../../redux/reducers/sso';
import { isOn } from 'feature-toggle-service';

@Component({
  standalone: false,
  selector: 'app-tile-sso',
  templateUrl: './tile-sso.component.html',
  styleUrls: ['./tile-sso.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TileSsoComponent implements OnInit {
  @Input() type = 's';
  ssoConfig$: Observable<SsoState>;
  isCountryEnabledWithEdenred = false;
  isCountryEnabledWithPlusMe = false;
  isEdenredADSupportFlowEnabled = isOn('PLUSME_CUS_SUPPORT_A');
  ssoPages = SsoPages;

  constructor(
    private readonly store: Store<State>,
    private readonly ssoService: SsoService,
    @Inject('EdenredSupportedCountries') private readonly edenredCountries
  ) {}

  @HostBinding() get class() {
    return 'tile-sso-links tile-links tile-links-' + this.type;
  }

  ngOnInit() {
    this.ssoConfig$ = this.store.pipe(
      select(customerConfig),
      filter(config => config.customerConfig.default_store_code && !config.isLoading),
      take(1),
      tap((config: CustomerState) => {
        this.store.dispatch(
          new InitSsoLinks({
            storeCode: config.customerConfig.default_store_code,
            userType: Number(config.customerConfig.is_decision_maker)
          })
        );

        for (const country of this.edenredCountries.countryList) {
          if (config.customerConfig.country_code === country) {
            this.isCountryEnabledWithEdenred = true;
            break;
          }
        }
        this.isCountryEnabledWithPlusMe = config.customerConfig.loyalty_enabled_for_account;
      }),
      switchMap(() => this.store.pipe(select(getSsoLinksState)))
    );
  }

  navigateBySSOLink(link: { code: string; external_link: string }) {
    if (link.code === 'connect') {
      this.ssoService.openExternalLink(link.external_link);
    } else {
      this.ssoService.redirectToSupportPage(link);
    }
  }

  navigateToAdSupportPage(link) {
    this.ssoService.redirectToSupportPage(link);
  }

  navigateToEdenredSupportPage() {
    this.ssoService.openEdenredSuppportUrl();
  }

}
